(function () {
  function initSlider(section) {
    const track = section.querySelector('.expert-slider__track');
    const cards = section.querySelectorAll('.expert-slider__card');
    const btnPrev = section.querySelector('.expert-slider__nav--prev');
    const btnNext = section.querySelector('.expert-slider__nav--next');
    const dotsContainer = section.querySelector('.expert-slider__dots');

    if (!track || !btnPrev || !btnNext || cards.length === 0) return;

    let current = 0;
    let touchStartX = 0;

    function getSlidesVisible() {
      return window.innerWidth >= 750 ? 2 : 1;
    }

    function getMax() {
      return Math.max(0, cards.length - getSlidesVisible());
    }

    function buildDots() {
      dotsContainer.innerHTML = '';
      const count = getMax() + 1;
      for (let i = 0; i < count; i++) {
        const dot = document.createElement('button');
        dot.className = 'expert-slider__dot';
        dot.setAttribute('aria-label', 'Slajd ' + (i + 1));
        dot.addEventListener('click', () => goTo(i));
        dotsContainer.appendChild(dot);
      }
    }

    function updateDots() {
      dotsContainer.querySelectorAll('.expert-slider__dot')
        .forEach((d, i) => d.classList.toggle('is-active', i === current));
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, getMax()));
      const cardWidth = cards[0].getBoundingClientRect().width;
      track.style.transform = `translateX(-${current * (cardWidth + 16)}px)`;
      updateDots();
    }

    btnPrev.addEventListener('click', () => goTo(current - 1));
    btnNext.addEventListener('click', () => goTo(current + 1));

    track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        diff > 0 ? goTo(current + 1) : goTo(current - 1);
      }
    }, { passive: true });

    window.addEventListener('resize', () => {
      buildDots();
      goTo(Math.min(current, getMax()));
    });

    buildDots();
    updateDots();
  }

  function boot() {
    document.querySelectorAll('.expert-slider-section').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();